import React, { useEffect } from "react";
import {
  AttachmentSelector,
  useMessageInputContext,
} from "stream-chat-react";

const CustomAttachmentSelector = () => {
  const {text, openCommandsList, closeCommandsList, showCommandsList} = useMessageInputContext('CustomAttachmentSelector');

  useEffect(() => {
    if(! text.startsWith('/'))
      closeCommandsList()
  }, [text, closeCommandsList])

  const handleButtonClick = () => {
    if(showCommandsList)
      closeCommandsList()
    else
      openCommandsList()
  }

  return (
    <>
      <AttachmentSelector/>
      <div className="str-chat__file-input-container" style={{width: '35px', paddingRight: '8px'}} onClick={handleButtonClick}>
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
          <path fill='var(--text-mid-emphasis)' d='M11 4h5l-3 7h4L9 22l2-8H7l4-10z'></path>
        </svg>
      </div>
    </>
  )
};

export default CustomAttachmentSelector;
